module.exports = __webpack_public_path__ + "img/question2.276dba74.svg";